/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import { anyTodo } from '@umati/dashboard-types';
import { MQTTWebsocketContext } from './MQTTComponent';

interface ISubscriptionComponentProps {
  subscriptionCallback: (data: any, topic: string) => void;
  topic: string;
  startReceivingData?: boolean;
  children?: any;
}

interface ISubscriptionInternalEx {
  mqttHandler: anyTodo;
}

interface ISubscriptionInternalState {
  data?: any;
  topic?: string;
}

class SubscriptionInternal extends Component<
  ISubscriptionComponentProps & ISubscriptionInternalEx,
  ISubscriptionInternalState
> {
  subscription: anyTodo = null;
  constructor(props) {
    super(props);
    // this.subscriptionCallback = this.props.subscriptionCallback;
    this.state = {
      data: null,
      topic: this.props.topic,
    };
  }

  componentDidMount() {
    if (this.props.startReceivingData || !Object.hasOwn(this.props, 'startReceivingData')) {
      this.subscribe();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      ...prevState,
      topic: nextProps.topic,
    };
  }

  subscribe = () => {
    if (this.subscription !== null && this.subscription !== undefined) this.subscription.unsubscribe();

    if (this.props.mqttHandler === null || this.props.mqttHandler === undefined) {
      console.log('No mqttHandler, is this subscription inside <MqttComponent>? No Subscription created.');
      return;
    }

    if (this.props.subscriptionCallback === null || this.props.subscriptionCallback === undefined) {
      console.log('No subscriptionCallback defined, nowhere to push the data. No Subscription created.');
      return;
    }

    if (this.state.topic === null) {
      console.log('topic is null. No Subscription created.');
      return;
    }

    const self = this;

    this.subscription = this.props.mqttHandler.createSubscription(this.state.topic, function (newData, topic) {
      const data = JSON.parse(newData);
      if (self.props.subscriptionCallback !== null && self.props.subscriptionCallback !== undefined) {
        self.props.subscriptionCallback(data, topic);
      } else {
        console.log('No subscriptionCallback defined anymore, nowhere to push the data');
      }
      self.setState({ data });
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.startReceivingData !== prevProps.startReceivingData || prevProps.topic !== this.props.topic) {
      this.subscribe();
    }
  }

  componentWillUnmount() {
    if (this.subscription && this.subscription.unsubscribe && typeof this.subscription.unsubscribe === 'function') {
      this.subscription.unsubscribe();
    }
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default function SubscriptionComponent(props: ISubscriptionComponentProps) {
  return (
    <MQTTWebsocketContext.Consumer>
      {(context) => <SubscriptionInternal {...props} mqttHandler={context} />}
    </MQTTWebsocketContext.Consumer>
  );
}
